<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  <fa-icon
    [icon]="faArrowDownLeftAndArrowUpRightToCenter"
    matTooltip="Close this chart"
    matTooltipPosition="right"
  ></fa-icon>
</button>
<h1 mat-dialog-title class="previewTitle">&nbsp;</h1>
<div mat-dialog-content>
  <ng-container *ngIf="chart && chart.canvasItemType == 'chart'">
    <app-table-chart
      *ngIf="chart.object.data.chartType == 'Table'"
      [data]="chart.object.data.chartObject"
      [chartData]="chart.object.data"
      [dataPoints]="chart.object.data.dataPoints"
      [type]="chart.object.data.chartType"
      [preview]="true"
      [hasEdit]="false"
    >
    </app-table-chart>
    <app-list-chart
      *ngIf="chart.object.data.chartType == 'List'"
      [data]="chart.object.data.chartObject"
      [chartData]="chart.object.data"
      [dataPoints]="chart.object.data.dataPoints"
      [type]="chart.object.data.chartType"
      [preview]="true"
      [hasEdit]="false"
    >
    </app-list-chart>
    <app-high-chart
      *ngIf="chart.object.data.chartType != 'Table'"
      [data]="chart.object.data.chartObject"
      [type]="chart.object.data.chartType"
      [preview]="true"
      [hasEdit]="false"
      [form]="form"
      [dataPoints]="chart.object.data.dataPoints"
      canvasType="dashboard"
    ></app-high-chart>
  </ng-container>
</div>
